import Router from "next/router";
import uuid from "uuid/v4";
import { CarDealerData, CarDealerForm } from "@comparaonline/contact-form-schema";
import { db } from "./store";
import { QueryParams, CarDealerCollection } from "./constants";

const { CarDealerName, CarDealerAgentId } = QueryParams;

const getQuoteUrl = (formId: string, carDealerData: CarDealerData) => {
  const { agentIdentificationNumber, massive, name } = carDealerData;
  const massiveQueryString = massive ? "&massive" : "";
  const queryString = `${CarDealerName}=${name}&${CarDealerAgentId}=${agentIdentificationNumber}&noPrefill${massiveQueryString}`;
  return `/seguro-automotriz/form/${formId}/quote?${queryString}`;
};

export const redirectToQuote = (carDealerData: CarDealerData) => {
  const formId = uuid();
  Router.push(getQuoteUrl(formId, carDealerData));
};

export const redirectToSuccess = (carDealerName: string) => {
  Router.push(`/seguro-automotriz/automotora/${carDealerName}/success`);
};

export const cleanCarData = (values: CarDealerForm): CarDealerForm => {
  const car =
    values.car &&
    Object.keys(values.car).reduce((obj, key) => {
      if (values.car[key]) {
        obj[key] = values.car[key];
      }
      return obj;
    }, {});

  return car
    ? {
        ...values,
        car
      }
    : values;
};

export const saveInFirestore = (values: CarDealerForm) =>
  db &&
  db
    .collection(CarDealerCollection)
    .doc()
    .set(cleanCarData(values));
